import { render, staticRenderFns } from "./ProcessCreateComprehensive.vue?vue&type=template&id=49ab3a38"
import script from "./ProcessCreateComprehensive.vue?vue&type=script&lang=js"
export * from "./ProcessCreateComprehensive.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports